import {
  Code, ShoppingBag, Cpu, Globe,
  PenTool, Server, Camera, Monitor, Briefcase,
  Mail, Cloud, Shirt, Coffee,
  CreditCard, Settings, MessageSquare,
  Brain, FileSignature, Database, TrendingUp,
  Edit3, Video, Home
} from 'lucide-react';
import { useMemo } from 'react';
import { getNamespace } from '../content';
import useLocale from '../hooks/useLocale';

// Import asset images
import conceptionWeb from '../Assets/Conception_web-MOBLIE FRINEDLY.png';
import shopifyEcommerce from '../Assets/shopify online e-commerce.jpg';
import shopifyPartner from '../Assets/tiguidou-creation-web-E-commerce-vente-en-ligne-Quebecstore-Agency-web.jpg';
import googleAds from '../Assets/Google-Ads-on behalf -of-Clients-services-TiguidouWeb.jpg';
import metaAds from '../Assets/meta-ads.jpg';
import domaineCA from '../Assets/domaine-canada-dot_ca-point-ca-tiguidouweb-de-50-an.png';
import courriels from '../Assets/courriels-professionnels-avec votre -domain-tiguidou-web-de seulent 12 $ per mois.jpg';
import hebergement from '../Assets/hebergement-tiguidouweb-service seulent 150cad-annee.jpg';
import logoDesign from '../Assets/Creation-De-Logos-Uniques-Et-Image-Professionnelle.png';
import vetementsTravail from '../Assets/Vêtements-de-Travail.png';
import articlesPromo from '../Assets/articles-promotionnels.png';
import cartesAffaires from '../Assets/cartes-d-affaires-Business-cards-design-and-printing-service-tiguidou-web-from-only-150-cad-get-over-200-cards.gif';
import googleWorkspace from '../Assets/google-workplace.png';
import microsoft365 from '../Assets/Microsoft-365-Installation-configuration- Office-Outlook-onedrive-Teams.png';
import stockageCloud from '../Assets/stockage-cloud.jpg';
import supportIT from '../Assets/support-it-supplementaire.jpg';
import chatbots from '../Assets/Chatbots-Messagerie.png';
import integrationIA from '../Assets/Integration-de-l-IA-au-Travail.png';
import gestionCRM from '../Assets/Gestion-de-Clientele-CRM).jpg';
import conseilsAffaires from '../Assets/conseils-affaires-photos.webp';
import contenuWeb from '../Assets/Contenu-Web.png';
import photographieCorp from '../Assets/Photographie-Corporative.png';
import logicielsSaaS from '../Assets/Logicielssur-Mesure-(SaaS).webp';
import crunkyCat from '../Assets/CrunkyCat Media.png';
import photographieDomicile from '../Assets/Photographie-a-Domicile.jpg';
import videoPRO from '../Assets/Video-PRO.jpg';
import aicaImage from '../Assets/AICA-(Intelligence-Artificielle).png';
import signatureElec from '../Assets/Signature-Electronique-Logicielles-Adobe-et-Plus.jpg';
import sauvegardeDonnees from '../Assets/Sauvegarde-de-Donnees.jpg';

export const services = [
  {
    id: "01",
    name: "Conception Web & Design UI/UX",
    href: "/services/conception-site-web-sherbrooke",
    icon: Code,
    desc: "Création de sites modernes, optimisés pour mobiles et tablettes avec une interface visuelle soignée.",
    highlight: true,
    image: conceptionWeb,
    color: "group-hover/icon:bg-blue-600 dark:group-hover/icon:bg-blue-600"
  },
  {
    id: "02",
    name: "AICA (Intelligence Artificielle)",
    href: "/aica/",
    icon: Cpu,
    desc: "Intégration de modèles d'IA sécurisés et personnalisés pour automatiser vos processus.",
    highlight: true,
    image: aicaImage,
    color: "group-hover/icon:bg-purple-600 dark:group-hover/icon:bg-purple-600"
  },
  {
    id: "03",
    name: "Boutiques en Ligne",
    href: "/services/boutique-en-ligne-ecommerce",
    icon: ShoppingBag,
    desc: "Tout ce qu'il vous faut pour vendre vos produits sur le web.",
    highlight: true,
    image: shopifyEcommerce,
    color: "group-hover/icon:bg-green-600 dark:group-hover/icon:bg-green-600"
  },
  {
    id: "04",
    name: "Partenaire Shopify",
    href: "/Tiguidou-web-Partenaire-Shopify-vente-enligne",
    icon: ShoppingBag,
    desc: "Expertise complète en création et optimisation de boutiques Shopify.",
    highlight: true,
    image: shopifyPartner,
    color: "group-hover/icon:bg-emerald-600 dark:group-hover/icon:bg-emerald-600"
  },
  {
    id: "05",
    name: "Google Ads & Meta Ads",
    href: "/services/publicite-google-ads-facebook",
    icon: Globe,
    desc: "Publicités ciblées sur Google, Facebook et Instagram pour attirer et convertir vos clients idéaux.",
    highlight: true,
    image: googleAds,
    color: "group-hover/icon:bg-red-600 dark:group-hover/icon:bg-red-600"
  },
  {
    id: "06",
    name: "Noms de Domaine (.CA)",
    href: "/services/hebergement-domaines",
    icon: Globe,
    desc: "Les clients canadiens sont 70% plus susceptibles de visiter un site .ca local.",
    highlight: true,
    image: domaineCA,
    color: "group-hover/icon:bg-indigo-600 dark:group-hover/icon:bg-indigo-600"
  },
  {
    id: "07",
    name: "Courriels Professionnels",
    href: "/services/courriels-professionnels",
    icon: Mail,
    desc: "Création et configuration de vos adresses courriels personnalisées (ex: nom@entreprise.ca).",
    highlight: true,
    image: courriels,
    color: "group-hover/icon:bg-yellow-500 dark:group-hover/icon:bg-yellow-500"
  },
  {
    id: "08",
    name: "Hébergement Web",
    href: "/services/hebergement-domaines",
    icon: Server,
    desc: "Espace sécurisé et haute performance pour loger votre site web.",
    highlight: true,
    image: hebergement,
    color: "group-hover/icon:bg-slate-700 dark:group-hover/icon:bg-slate-700"
  },
  {
    id: "09",
    name: "Identité de Marque & Logo",
    href: "/services/identite-visuelle-branding",
    icon: Briefcase,
    desc: "Création de logos uniques et d'une image professionnelle pour votre entreprise.",
    image: logoDesign,
    color: "group-hover/icon:bg-pink-600 dark:group-hover/icon:bg-pink-600"
  },
  {
    id: "10",
    name: "Vêtements de Travail",
    href: "/soumission-projet-web-gratuit",
    icon: Shirt,
    desc: "Design de vêtements corporatifs personnalisés pour votre équipe.",
    image: vetementsTravail,
    color: "group-hover/icon:bg-orange-600 dark:group-hover/icon:bg-orange-600"
  },
  {
    id: "11",
    name: "Articles Promotionnels",
    href: "/soumission-projet-web-gratuit",
    icon: Coffee,
    desc: "Design de tasses, bouteilles et accessoires personnalisés pour vos clients.",
    image: articlesPromo,
    color: "group-hover/icon:bg-teal-600 dark:group-hover/icon:bg-teal-600"
  },
  {
    id: "12",
    name: "Cartes d'Affaires",
    href: "/services/cartes-affaires",
    icon: CreditCard,
    desc: "Design professionnel de vos cartes de visite pour laisser une impression durable.",
    image: cartesAffaires,
    color: "group-hover/icon:bg-rose-600 dark:group-hover/icon:bg-rose-600"
  },
  {
    id: "13",
    name: "Google Workspace",
    href: "/services/support-informatique-microsoft365-google",
    icon: Mail,
    desc: "Mise en place de Gmail pro, Google Drive et des outils collaboratifs Google.",
    image: googleWorkspace,
    color: "group-hover/icon:bg-cyan-600 dark:group-hover/icon:bg-cyan-600"
  },
  {
    id: "14",
    name: "Microsoft 365",
    href: "/services/support-informatique-microsoft365-google",
    icon: Monitor,
    desc: "Installation et configuration de la suite Office, Outlook et Teams pour votre équipe.",
    image: microsoft365,
    color: "group-hover/icon:bg-sky-600 dark:group-hover/icon:bg-sky-600"
  },
  {
    id: "15",
    name: "Stockage Cloud",
    href: "/services/stockage-cloud",
    icon: Cloud,
    desc: "Configuration de vos espaces de stockage en ligne pour accéder à vos fichiers partout.",
    image: stockageCloud,
    color: "group-hover/icon:bg-blue-500 dark:group-hover/icon:bg-blue-500"
  },
  {
    id: "16",
    name: "Support Informatique",
    href: "/services/support-informatique-microsoft365-google",
    icon: Settings,
    desc: "Aide technique et dépannage pour vos outils de travail au quotidien.",
    image: supportIT,
    color: "group-hover/icon:bg-slate-600 dark:group-hover/icon:bg-slate-600"
  },
  {
    id: "17",
    name: "Chatbots & Messagerie",
    href: "/services/chatbots-messagerie",
    icon: MessageSquare,
    desc: "Installation de fenêtres de clavardage pour offrir un support instantané sur votre site.",
    image: chatbots,
    color: "group-hover/icon:bg-emerald-600 dark:group-hover/icon:bg-emerald-600"
  },
  {
    id: "18",
    name: "Intégration de l'IA au Travail",
    href: "/services/integration-ia-travail",
    icon: Brain,
    desc: "Accompagnement pour introduire l'IA dans votre équipe afin d'augmenter la productivité.",
    image: integrationIA,
    color: "group-hover/icon:bg-fuchsia-600 dark:group-hover/icon:bg-fuchsia-600"
  },
  {
    id: "19",
    name: "Signature Électronique",
    href: "/services/signature-electronique",
    icon: FileSignature,
    desc: "Mise en place de solutions comme DocuSign pour signer vos contrats officiels en ligne.",
    image: signatureElec,
    color: "group-hover/icon:bg-violet-600 dark:group-hover/icon:bg-violet-600"
  },
  {
    id: "20",
    name: "Sauvegarde de Données",
    href: "/services/sauvegarde-donnees",
    icon: Database,
    desc: "Solutions de copie de sécurité automatique pour protéger vos documents importants.",
    image: sauvegardeDonnees,
    color: "group-hover/icon:bg-zinc-600 dark:group-hover/icon:bg-zinc-600"
  },
  {
    id: "21",
    name: "Gestion de Clientèle (CRM)",
    href: "/services/marketing-crm-automation",
    icon: PenTool,
    desc: "Outils simples pour organiser vos contacts, vos suivis et vos ventes.",
    image: gestionCRM,
    color: "group-hover/icon:bg-amber-600 dark:group-hover/icon:bg-amber-600"
  },
  {
    id: "22",
    name: "Conseils d'Affaires",
    href: "/services/conseils-affaires",
    icon: TrendingUp,
    desc: "Accompagnement stratégique pour optimiser votre modèle d'entreprise.",
    image: conseilsAffaires,
    color: "group-hover/icon:bg-stone-600 dark:group-hover/icon:bg-stone-600"
  },
  {
    id: "23",
    name: "Création de Contenu Web",
    href: "/services/creation-contenu-web",
    icon: Edit3,
    desc: "Rédaction et textes pour dynamiser votre site et vos réseaux sociaux.",
    image: contenuWeb,
    color: "group-hover/icon:bg-red-500 dark:group-hover/icon:bg-red-500"
  },
  {
    id: "24",
    name: "Photographie Corporative",
    href: "/services/photographie-video-corporative",
    icon: Camera,
    desc: "Photos de votre équipe et de votre entreprise pour une image de marque de qualité.",
    image: photographieCorp,
    color: "group-hover/icon:bg-indigo-500 dark:group-hover/icon:bg-indigo-500"
  },
  {
    id: "25",
    name: "Vidéo PRO",
    href: "/services/photographie-video-corporative",
    icon: Video,
    desc: "Création de capsules vidéo pour présenter vos services ou vos produits.",
    image: videoPRO,
    color: "group-hover/icon:bg-purple-500 dark:group-hover/icon:bg-purple-500"
  },
  {
    id: "26",
    name: "Logiciels sur Mesure (SaaS)",
    href: "/services/developpement-saas-sur-mesure",
    icon: Server,
    desc: "Développement de plateformes logicielles personnalisées selon vos besoins d'affaires.",
    image: logicielsSaaS,
    color: "group-hover/icon:bg-blue-700 dark:group-hover/icon:bg-blue-700"
  },
  {
    id: "27",
    name: "Photographie à Domicile",
    href: "/services/photographie-domicile",
    icon: Home,
    desc: "Service de photos de famille ou portraits personnels, chez vous sur appel.",
    image: photographieDomicile,
    color: "group-hover/icon:bg-rose-500 dark:group-hover/icon:bg-rose-500"
  },
  {
    id: "28",
    name: "CrunkyCat Media",
    href: "/services/crunkycat-media-visuels",
    icon: Camera,
    desc: "Vitrine exclusive de contenus visuels et médias de stock prêts à l'usage.",
    image: crunkyCat,
    color: "group-hover/icon:bg-pink-500 dark:group-hover/icon:bg-pink-500"
  },
];

export const shopCategories = [
  { id: '01', name: "Vêtements Promotionnels", href: "/boutique/vetements-promotionnels" },
  { id: '02', name: "Matériel Publicitaire", href: "/boutique/materiel-publicitaire" },
  { id: '03', name: "Équipement Informatique", href: "/boutique/equipement-informatique-pos" },
  { id: '04', name: "Livres Numériques", href: "/boutique/livres-numeriques-gratuits" },
];

/** Localize service name/desc from aica-web-data while keeping icons/hrefs. */
export function localizeServices(lang = 'fr') {
  const pack = getNamespace('services', lang) || {};
  return services.map((service) => ({
    ...service,
    name: pack[`${service.id}.name`] || service.name,
    desc: pack[`${service.id}.desc`] || service.desc,
  }));
}

export function localizeShopCategories(lang = 'fr') {
  const pack = getNamespace('services', lang) || {};
  return shopCategories.map((cat) => ({
    ...cat,
    name: pack[`shop.${cat.id}`] || cat.name,
  }));
}

export function useLocalizedServices(langProp) {
  const routeLang = useLocale();
  const lang = langProp || routeLang;
  return useMemo(() => localizeServices(lang), [lang]);
}
